import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import WritingSample from '../components/WritingSample';

export default function WritingSamplePage() {
  return (
    <>
      <Navbar />
      <WritingSample />
      <Footer />
    </>
  );
}
